import { h, Fragment } from 'preact'
import { useState } from 'preact/hooks'
import { tagParser, linkParser, proxymedia } from '../../js/modules/utilities.js'
import { attributesAnalytics } from '../../js/modules/component'
import fibres from './fibres.svg'

export const TuileOffre2 = ({ theme, title, description, tag, legalNotice, prefix_price, per_month, price, image, sr_only, mentions, URL, analytics }) => {
   document.documentElement.style.setProperty('--img-fibres-offre', `url(${fibres})`)

   return (
      <Fragment>
         <a
            href={URL}
            class={`tuile-offre-2 theme-${theme}`}
            {...attributesAnalytics(analytics)}
         >
            {tag && (
               <div class="tag">
                  <div class="ob1-tag ob1-tag-primary">{tag}</div>
               </div>
            )}

            <div class="content">
               <div class="text mt-1">
                  <h3 class="lead font-weight-bold mb-0" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></h3>
                  <p class="h4 description" dangerouslySetInnerHTML={{ __html: tagParser(description) }}></p>
               </div>
               <div class="image">
                  <img src={proxymedia(image)} alt="" loading="lazy" />
               </div>
            </div>

            <div class="price ob1-price text-right" data-ob1-component="Price">
               <span class="sr-only">{sr_only}</span>
               <p aria-hidden="true">
                  {prefix_price && <span class="ob1-price-from">à partir de</span>}

                  <span class="ob1-price-amount">{price}&nbsp;€</span>

                  {per_month && <span class="ob1-price-by-month"> {per_month && '/mois'}</span>}

                  <span class="ob1-price-promo-duration" dangerouslySetInnerHTML={{ __html: tagParser(mentions) }}></span>
               </p>
            </div>
         </a>
         {(legalNotice.content || legalNotice.title) && <LegalNotice {...legalNotice} theme={theme} index="offreMEV" />}
      </Fragment>
   )
}

const LegalNotice = ({ showButtonLabel, title, content, theme, index }) => {
   const [legalState, setLegalState] = useState(false)

   const toggleLegals = () => {
      setLegalState(!legalState)
   }

   const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
         toggleLegals()
      }
   }

   return (
      <div class={`offerLegalNotice ${legalState ? 'openContent' : ''}`}>
         <div id={`legalNoticePanel${index}`} class={`contentLegalNotice ${theme === 'white' ? 'bg-white' : 'bg-dark'}`} aria-hidden={!legalState}>
            <span class={`closeLegal ${theme === 'white' ? 'text-dark' : 'text-white'}`} onClick={toggleLegals}>
               &times;
            </span>
            <div class={`contentText ${theme === 'white' ? 'text-dark' : 'text-white'}`}>
               {title && <div class="lead font-weight-bold" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></div>}
               {content && <div dangerouslySetInnerHTML={{ __html: tagParser(linkParser(content)) }}></div>}
            </div>
         </div>
         <span
            class="showButton"
            onClick={toggleLegals}
            onKeyDown={handleKeyDown}
            tabindex="0"
            role="button"
            aria-expanded={legalState}
            aria-pressed={legalState}
            aria-controls={`legalNoticePanel${index}`}
         >
            <span class={`icon icon-info ${theme === 'white' ? 'text-dark' : 'text-white'}`} aria-hidden="true"></span>
            <strong class={theme === 'white' ? 'text-dark' : 'text-white'}>{showButtonLabel}</strong>
         </span>
      </div>
   )
}
